import * as React from 'react'
import styled from 'styled-components'
import { styleCheckList } from '../../../lib/styles/Style'
import { Icon } from '../Icon'

export const StyledCheckList = styled.ul`
  ${styleCheckList}
`

export const CheckListItem = ({ children }) => {
  return (
    <li>
      <Icon name="check" />
      {children}
    </li>
  )
}
